import { validations } from './validations';
const dosage = [
  { value: 'até 2 doses', label: 'Até 2 doses' },
  { value: 'até 4 doses', label: 'Até 4 doses' },
  { value: 'até 8 doses', label: 'Até 8 doses' },
  { value: 'até 12 doses', label: 'Até 12 doses' },
  { value: 'mais de 12 doses', label: 'Mais de 12 doses' },
];
/**
 * Questions about drinking habit
 */
export const drinkingHabitQuestions = [
  {
    id: 'beer-drinking-dosage',
    question: 'Voltando à falar sobre cervejas com álcool: Quantas doses de cerveja (com álcool) você bebe semanalmente?',
    subtitle: 'Considere que 1 dose = 1 lata ou long neck (350ml)',
    type: 'radio',
    options: dosage,
    validation: validations.required,
    nextQuestion: (answer, allAswers) => {
      if (allAswers['other-drinks']['selections'].includes('não bebo nada além da cerveja')) {
        return 'alcohol-reduction-measures'
      }
      return 'other-drinking-dosage'
    },
  },
  {
    id: 'other-drinking-dosage',
    question: 'E com relação a outras bebidas alcoólicas?',
    subtitle: 'Considere que 1 dose = 1 taça de vinho (150ml) ou 40ml de destilado',
    type: 'radio',
    options: dosage,
    validation: validations.required,
  },
  {
    id: 'alcohol-consumption',
    question: 'Avaliando o seu consumo de bebidas alcoólicas no geral, você o considera...',
    type: 'radio',
    options: [
      { value: 'baixo', label: 'Baixo' },
      { value: 'moderado', label: 'Moderado' },
      { value: 'alto', label: 'Alto' },
      { value: 'problemático', label: 'Problemático' },
    ],
    validation: validations.required,
  },
  {
    id: 'alcohol-reduction-measures',
    question: 'Quando se fala em ter um estilo de vida equilibrado ou moderação, que medidas você tem adotado (ainda que parcialmente) ou tem interesse em adotar? Responda até três.',
    subtitle: 'Considerando que: Baixo teor alcoólico = entre 0,5% e 3%, e Cerveja regular = acima de 4%.',
    type: 'checkbox',
    options: [
      { value: 'consumir cerveja zero álcool e baixa caloria', label: 'Consumir cerveja zero álcool e baixa caloria' },
      { value: 'consumir cerveja regular mas com baixa caloria', label: 'Consumir cerveja regular mas com baixa caloria' },
      { value: 'consumir cerveja de baixo teor alcoólico', label: 'Consumir cerveja de baixo teor alcoólico' },
      { value: 'consumir cerveja de baixo teor alcoólico e baixa caloria', label: 'Consumir cerveja de baixo teor alcoólico e baixa caloria' },
      { value: 'consumir cerveja zero álcool', label: 'Consumir cerveja zero álcool' },
      { value: 'consumir em menor quantidade cerveja regular', label: 'Consumir em menor quantidade cerveja regular' },
      { value: 'parar de consumir qualquer tipo de cerveja', label: 'Parar de consumir qualquer tipo de cerveja' },
      { value: 'nenhuma, não estou preocupado essas questões', label: 'Nenhuma, não estou preocupado essas questões' },
    ],
    exclusiveOptions: ['nenhuma, não estou preocupado essas questões'],
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1, 3),
  },
  {
    id: 'beer-budget',
    question: 'Quanto você gasta por mês com cervejas?',
    type: 'radio',
    options: [
      { value: 'até R$ 100,00', label: 'Até R$ 100,00' },
      { value: 'entre R$ 101,00 e R$ 200,00', label: 'Entre R$ 101,00 e R$ 200,00' },
      { value: 'entre R$ 201,00 e R$ 300,00', label: 'Entre R$ 201,00 e R$ 300,00' },
      { value: 'entre R$ 301,00 e R$ 400,00', label: 'Entre R$ 301,00 e R$ 400,00' },
      { value: 'entre R$ 401,00 e R$ 500,00', label: 'Entre R$ 401,00 e R$ 500,00' },
      { value: 'entre R$ 501,00 e R$ 600,00', label: 'Entre R$ 501,00 e R$ 600,00' },
      { value: 'mais de R$ 600,00', label: 'Mais de R$ 600,00' },
    ],
    validation: validations.required,
    nextQuestion: (answer, allAswers) => {
      if (allAswers['other-drinks']['selections'].includes('não bebo nada além da cerveja')) {
        return 'email'
      }
      return 'other-drinks-budget';
    }
  },
  {
    id: 'other-drinks-budget',
    question: 'Quanto você gasta por mês com outras bebidas?',
    type: 'radio',
    options: [
      { value: 'até R$ 100,00', label: 'Até R$ 100,00' },
      { value: 'entre R$ 101,00 e R$ 200,00', label: 'Entre R$ 101,00 e R$ 200,00' },
      { value: 'entre R$ 201,00 e R$ 300,00', label: 'Entre R$ 201,00 e R$ 300,00' },
      { value: 'entre R$ 301,00 e R$ 400,00', label: 'Entre R$ 301,00 e R$ 400,00' },
      { value: 'entre R$ 401,00 e R$ 500,00', label: 'Entre R$ 401,00 e R$ 500,00' },
      { value: 'entre R$ 501,00 e R$ 600,00', label: 'Entre R$ 501,00 e R$ 600,00' },
      { value: 'mais de R$ 600,00', label: 'Mais de R$ 600,00' },
    ],
    validation: validations.required,
  },
  {
    id: 'session-beer-taxes',
    question: 'Você concorda que bebidas com menor teor alcoólico devem ter impostos menores?',
    type: 'radio',
    options: [
      { value: 'sim', label: 'Sim' },
      { value: 'não', label: 'Não' },
    ],
    validation: validations.required,
  }
];
